import React, { useState } from 'react'
import styled from 'styled-components'

import withRenderClientsideOnly from 'components/utils/withRenderClientsideOnly'
import { trackPageShared, Method } from '../../analytics/share'

import ShareIcon from '../icons/Share'
import TrayModal from '../modals/TrayModal'

import Button from './Button'
import ShareList from './ShareList'

const EntryButton = styled(Button).attrs({
  uppercase: false,
})`
  display: flex;
  align-items: center;
  justify-content: center;
`

type ButtonLikeProps = Omit<React.ComponentProps<typeof Button>, 'onClick'>

type ModalProps = {
  isOpen: boolean
  onRequestClose: () => any
  title: string
  url: string
  source: Parameters<typeof trackPageShared>[0]['source']
  excludeMethods?: Method[]
  message?: string
}

const Modal = withRenderClientsideOnly(
  ({
    isOpen,
    onRequestClose,
    title,
    url,
    source,
    excludeMethods = [],
    message,
  }: ModalProps) => (
    <TrayModal
      title={title}
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      narrowOnDesktop
    >
      <ShareList
        url={url}
        excludeMethods={excludeMethods}
        message={message || title}
        onShare={(method) => {
          trackPageShared({ method, source, url })
        }}
      />
    </TrayModal>
  )
)

type ShareButtonProps = {
  title: string
  url: string
  source: Parameters<typeof trackPageShared>[0]['source']
  EntryButtonComponent?: React.ComponentType<ButtonLikeProps>
  excludeMethods?: Method[]
  message?: string
} & ButtonLikeProps

const ShareButton = ({
  title,
  url,
  source,
  EntryButtonComponent = EntryButton,
  excludeMethods = [],
  message,
  ...props
}: ShareButtonProps) => {
  const [open, setOpen] = useState(false)

  return (
    <>
      <EntryButtonComponent ghost onClick={() => setOpen(true)} {...props}>
        {props.children || (
          <>
            <ShareIcon />
            <span>Share</span>
          </>
        )}
      </EntryButtonComponent>

      <Modal
        isOpen={open}
        onRequestClose={() => setOpen(false)}
        title={title}
        url={url}
        source={source}
        excludeMethods={excludeMethods}
        message={message}
      />
    </>
  )
}

export default ShareButton
